import { combineReducers } from 'redux';

import consultaReabilitacao from './consultaReabilitacao/reducer';

export default combineReducers({
	consultaReabilitacao,
});
